import { i18n } from '@international/mastodon-i18n';
import { DateObject } from './interfaces';

export const selectYear = i18n.getStr(
  'components.Verification.EmploymentMultidocPanel.selectYear',
);
export const multiDocuments = 'multi_documents';
export const getSelectYearOption = () => [
  {
    value: selectYear,
    name: selectYear,
    uploadId: '',
    disabled: false,
  },
];
export const dateObject = (id: string, uploadId: string): DateObject => {
  return {
    id,
    uploadId,
    value: '',
    name: '',
    disabled: false,
    type: 'EmploymentProof',
    exceptionType: multiDocuments,
    requiredForVerification: false,
  };
};
